import App from './App.vue'
import Interceptors from '@/plugins/interceptors'
import Vue from 'vue'
import i18n from '@/plugins/vue-i18n'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18nCountries from './plugins/i18n-countries'
import '@/styles/application.scss'
import './plugins/fragment';
import '@/directives/osg-date';
import '@/directives/osg-pattern';

Vue.config.productionTip = false

const interceptors = Interceptors(store)

i18nCountries();

new Vue({
  router,
  store,
  vuetify,
  i18n,
  interceptors,
  render: h => h(App)
}).$mount('#app')
